import React from 'react';

import { useSellConfirmStore } from '../../../store/digital-gold/sell-confirm-store';
import { PaymentStatus } from './PaymentStatus';

export const SellPaymentScreen = () => {
  const sellConfirmData = useSellConfirmStore((state) => state.confirmData);
  const statusProps = {
    amount: sellConfirmData.goldValue,
    goldValue: sellConfirmData.goldValue,
    payableAmount: sellConfirmData.goldValue,
    weight: sellConfirmData.weight,
    transactionId: sellConfirmData.transactionId,
    gst: 0,
    status: sellConfirmData.message,
    successMessage: 'Gold Sale Successful',
    failureMessage: 'Gold Sale Failed',
    inprogressMessage: 'Gold Sale In Progress',
    flowType: 'SELL',
  };

  return <PaymentStatus {...statusProps} />;
};

// export default SellPaymentScreen;
